<template>
    <div>
        <v-dialog max-width="700" persistent v-model="$store.getters.participationModal">
            <v-card>
                <v-card-title class="primary">
                    <span class="headline white--text text-center">Συμμετοχή Στο Πρόγραμμα Εύδοξος</span>
                </v-card-title>
                <v-card-text>
                    <v-container class="">
                        <p>Παρακαλούμε επιβεβαιώστε την συμμετοχή σας στο πρόγραμμα Εύδοξος για το επόμενο ακαδημαϊκό έτος.</p>
                        <p>Αν επιλέξετε "Ναι" τα βιβλία σας θα παραμείνουν διαθέσιμα προς επιλογή από τις Γραμματείες. Εάν επιλέξετε "Όχι"
                            τα βιβλία σας δεν θα είναι διαθέσιμα και πρόκειται να αφαιρεθούν από τις επιλογές συγγραμμάτων στις οποίες συμμετέχουν.</p>
                        <p>Η επιβεβαίωση αυτή θα πρέπει να γίνει το αργότερο μέχρι τις {{toDate()}}, σε αντίθετη περίπτωση ο λογαριασμός σας θα
                            απενεργοποιηθεί αυτόματα και τα βιβλία σας δεν θα είναι διαθέσιμα προς επιλογή από τις Γραμματείες.</p>
                        <p>
                            <b>Επιβεβαιώνω ότι επιθυμώ να συμμετάσχω στο πρόγραμμα Εύδοξος κατά το ακαδημαϊκό έτος {{createTheDate()}}.</b>
                        </p>
                        <v-row>
                            <v-col>
                                <v-btn block outlined color="green" @click="updateEudoxusMembership(true)">
                                    <v-icon>done</v-icon> Ναι
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn block outlined color="red" @click="updateEudoxusMembership(false)">
                                    <v-icon>remove_circle_outline</v-icon> Οχι
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn block outlined color="blue" @click="exitInfoModal">
                                    <v-icon>redo</v-icon> Αργοτερα
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <a href="https://eudoxus.gr/Files/Terms_and_Conditions_v1.pdf" target="_blank">Όροι και Προϋποθέσεις Συμμετοχής</a>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import utils from "../utilities";
    import request from "../requests";

    export default {
        name: "ParticipationModal",
        data: () => ({
            academicYear: '',
            membershipConfirm: '',
            eBookstoreMembershipConfirm: '',
            askForEBookstoreMembership: false,
        }),

        methods: {

            askForEBookstoreMembershipIfPublisherIsNotAllocator(){
                if(this.$store.getters.homePageInformation.type == 'Allocator'){
                    this.askForEBookstoreMembership=false;
                    this.updateEudoxusMembership(true, false);
                }else{
                    this.askForEBookstoreMembership=true;
                }

            },

            //participation in Eudoxus Program
            participation() {

            },

            //no participation in Eudoxus Program
            noParticipation(){

            },

            // exit from modal
            exitInfoModal() {
                this.askForEBookstoreMembership = false;
                this.$store.commit('setParticipationModal', false);
            },

            updateEudoxusMembership(eudoxusMember, eBookstoreMember) {
                this.membershipConfirm = eudoxusMember;
                this.eBookstoreMembershipConfirm = eBookstoreMember;

                var eudoxusMembershipRequestModel = {};
                eudoxusMembershipRequestModel.entityId = this.$store.getters.homePageInformation.id;
                eudoxusMembershipRequestModel.year = this.$store.getters.activeYear + 1 ;
                eudoxusMembershipRequestModel.eudoxusMembership = eudoxusMember;
                eudoxusMembershipRequestModel.eBookstoreMembership = eBookstoreMember;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.setEudoxusMembershipForPublisher(token, eudoxusMembershipRequestModel, this.setEudoxusMembershipForPublisherCallBack);
                    this.$store.commit('setParticipationModal', false);
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            setEudoxusMembershipForPublisherCallBack(response) {
                this.askForEBookstoreMembership = false;
                this.$store.commit('setHomePageInformation', response);
                this.$store.commit('setLoadingModal', false);
                if(!this.membershipConfirm){
                    alert(" Ο λογαριασμός σας έχει απενεργοποιηθεί για το ακαδημαικό έτος " + this.createAlertDate() + " και τα βιβλία σας πρόκειται " +
                        "να αφαιρεθούν από τις επιλογές συγγραμμάτων στις οποίες συμμετέχουν. Αν αυτή η ενέργεια έγινε κατά λάθος, " +
                        "επικοινωνήστε με το Γραφείο Αρωγής Χρηστών στο 215 215 7850.")
                }

                if(this.eBookstoreMembershipConfirm){
                    alert(" Παρακαλούμε περιμένετε για μεταφερθείτε στην Βιβλιοθήκη Ηλεκτρονικών Συγγραμμάτων");
                    this.$store.commit('setLoadingModal', true);
                    request.redirectToBookstore(this.redirectToBookstoreCallBack);
                }

            },

            redirectToBookstoreCallBack(response){
                this.$store.commit('setLoadingModal', false);
                window.open(response.redirectUrl,"_self");
            },

            createAlertDate(){
                var editedYear = this.$store.getters.editedYear;

                if (editedYear != '' ) {
                    return  editedYear + ' - ' + parseInt(editedYear + 1);
                }
                return '--'
            },

            createTheDate(){

                var year = this.$store.getters.activeYear + 1 ;

                if (year != '' ) {
                    return  year + ' - ' + parseInt(year + 1);
                }
                return '--'
            },

            toDate() {

                var homeInformation = this.$store.getters.homePageInformation;

                if (homeInformation.publisherDataEntryValidDates != undefined) {
                    return homeInformation.publisherDataEntryValidDates.PUBLISHER_MEMBERSHIP_TO_DATE;
                }
            }
        }
    }
</script>

<style scoped>

</style>